import {
    patchState,
    signalStore,
    withMethods,
    withState,
} from '@ngrx/signals';

type MensajeErrorState = {
    mensaje: string | null;
};

const initialState: MensajeErrorState = {
    mensaje: null
};

export const MensajeErrorState = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods((store) => ({
        actualizarMensaje(mensaje: string | null): void {
            patchState(store, { mensaje })
        },
    }))
);
